import { render, staticRenderFns } from "./InputGroupPage.vue?vue&type=template&id=28d1d87e&"
import script from "./InputGroupPage.vue?vue&type=script&lang=js&"
export * from "./InputGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./InputGroupPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports